// Auto-generated by scripts/update-blog-slugs.js
export const POST_SLUGS = [
  "docra-built-around-how-you-invest",
  "introducing-docra",
  "join-our-pilot",
  "the-40-hour-gap"
];
